module.exports = __webpack_public_path__ + "img/bank-21-sb.47f215a3.svg";